import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { HeaderChips } from './Header.Chips/Header.Chips.es.js';
import { HeaderProvider } from './Header.Context/Header.Context.es.js';
import { HeaderDescription } from './Header.Description/Header.Description.es.js';
import { HeaderHead } from './Header.Head/Header.Head.es.js';
import { HeaderNumbers } from './Header.Numbers/Header.Numbers.es.js';

const Header = ({ children, ...props })=>{
    return jsx(HeaderProvider, {
        ...props,
        children: jsx("header", {
            className: classNames('cb-header', props.variant),
            children: children
        })
    });
};
Header.displayName = 'Header';
Header.Numbers = HeaderNumbers;
Header.Description = HeaderDescription;
Header.Head = HeaderHead;
Header.Chips = HeaderChips;

export { Header, Header as default };
//# sourceMappingURL=Header.es.js.map
